import React, { useEffect, useState } from "react";
import { API } from "@/lib/api";
import { UserCheck } from "lucide-react";

export const ReferrerBanner = ({ code }) => {
  const [r, setR] = useState(null);
  useEffect(() => {
    if (!code) { setR(null); return; }
    fetch(`${API}/public/referrer?code=${encodeURIComponent(code)}`).then((x) => x.json()).then(setR).catch(() => setR(null));
  }, [code]);
  if (!r?.valid) return null;
  return (
    <div data-testid="referrer-banner" className="flex items-center gap-2 rounded-lg border border-gold/40 bg-gold/10 px-3 py-2 text-xs text-white">
      <UserCheck className="w-4 h-4 text-gold flex-shrink-0" />
      <span>You are joining under <b className="text-gold">{r.name}</b>{r.member_no ? ` (Member #${r.member_no})` : ""}</span>
    </div>
  );
};
